import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpErrorResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import {
  ImplementsBreifViewModel,
  InspectedImplementsViewModel,
  InspectionRequestModel,
  InspectionObservationPointsViewModel,
  UpdateInspectionImagePhotoViewModel,
  NewImageForImplementInspectionViewModel,
  InspectImplementQuestionViewModel,
  NewImageForGeneralQuestionsOnInspectionModel,
  UploadNewImagesToObservationPointModel,
  UpdateObservationCommentViewModel,
  UpdateImplementLevelEquipmentAnswersModel,
  ObservationQuestionListViewModel,
  InspectionOverallCommentUpdateCommentViewModel,
  AddNewMeasurementToObservationPointModel,
  ComponentReprtGroupUpdateModel,
  UpdateIncludeReportObservation,
  ComponentTypes,
  ReportOptionsVm,
  ReportOptionValue,
  PreInspectionChecklistVM,
  UpdatePreCheckListCommentViewModel,
  PreCheckListAnswerUpdate,
  UpdatePreInspectionImagePhotoViewModel,
  WearStatusPackages,
  UpdateComponentImageViewModel,
  AssetDetail,
  WorkOrderUpdate,
  OBSseveityList,
  InspectionCompTypeCompObsPoints,
} from './inspection.model';
import { catchError } from 'rxjs/operators';
import { EquipmentDetailsParams, Tuple } from '../setup-equipment/setup-equipment.model';
import { ImplementDetails } from '../implement-details/implement-details';
import { FECRPrePostAdditionalObsVM } from '../FECR/FECRDashboard/fecr-search-panel/fecr-search-panel.model';
import { GenericIdName } from '../setup-implement/setup-implement.model';
import { Subject } from 'rxjs';


@Injectable()
export class NewInspectionService {






  constructor(private _http: HttpClient) { }


  public GetPreInspectionChecklistInfo(inspectionId: number): Observable<PreInspectionChecklistVM[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<PreInspectionChecklistVM[]>('api/GETNewInspection/GetInspectionPreChecklist', options)
      .pipe(catchError(this.handleError));
  }


  ChangePreCheckListAnswer(AnswerId: number, NewAnswer: boolean): any {
    const model = new PreCheckListAnswerUpdate();
    model.AnswerId = AnswerId;
    model.NewAnswer = NewAnswer;
    return this._http.post('api/GETNewInspection/UpdatePreChecklistAnswer', model)
      .pipe(catchError(this.handleError));
  }

  uploadNewPhotoToPreChecklistAnswer(PreChecklist: PreInspectionChecklistVM, newPhoto: string): any {
    const model = new UploadNewImagesToObservationPointModel();
    model.ImageData = newPhoto;
    model.ObservationPointInspectionId = PreChecklist.ChecklistAnswerId;
    return this._http.post('api/GETNewInspection/UploadNewPhotoToCheckList', model)
      .pipe(catchError(this.handleError));
  }

  public updatePreInpsectionCheckListImage(AnswerId: number, imageData: string, ImageId: number) {
    const model = new UpdatePreInspectionImagePhotoViewModel();
    model.ImageId = ImageId;
    model.ImageData = imageData;
    model.AnswerId = AnswerId;

    console.log("Model,", model)
    return this._http.post('api/GETNewInspection/UpdatePreInspectionImage', model)
      .pipe(catchError(this.handleError));
  }

  public deleteChecklistAnswerImage(imageId: number): Observable<any> {
    const options = {
      params: new HttpParams()
        .set('imageId', imageId.toString())
    };
    return this._http.get('api/GETNewInspection/DeletePreChecklistImages', options)
      .pipe(catchError(this.handleError));
  }

  public GetAllImplementByEquipmentId(equipmentId: number): Observable<ImplementsBreifViewModel[]> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get<ImplementsBreifViewModel[]>('api/GETNewInspection/GetAllImplementsByEquipmentId', options)
      .pipe(catchError(this.handleError));
  }
  public GetAllImplementonInventory(get_auto: number): Observable<ImplementsBreifViewModel[]> {
    const options = {
      params: new HttpParams().set('get_auto', get_auto.toString())
    };
    return this._http.get<ImplementsBreifViewModel[]>('api/GETNewInspection/GetAllImplementonInventory', options)
      .pipe(catchError(this.handleError));
  }

  //getEquipmentDetails
  public getEquipmentDetails(equipmentId: number): Observable<EquipmentDetailsParams> {
    const options = {
      params: new HttpParams().set('equipmentId', equipmentId.toString())
    };
    return this._http.get<EquipmentDetailsParams>('api/equipmentdetails/GetEquipmentDetails', options)
      .pipe(catchError(this.handleError));
  }

  uploadPhotoToGeneralQuestionImages(
    implementInspection: InspectedImplementsViewModel,
    inspectionGeneralQuestion: InspectImplementQuestionViewModel,
    newPhoto: string): Observable<Tuple> {
    const model = new NewImageForGeneralQuestionsOnInspectionModel();
    model.ImageId = 0;
    model.ImageData = newPhoto;
    model.ImplementInspectionId = implementInspection.ImplementInspectionId;
    model.InspectionGeneralQuestionId = inspectionGeneralQuestion.Id;
    return this._http.post<Tuple>('api/GETNewInspection/UploadNewImagesToInspectionGeneralQuestions', model)
      .pipe(catchError(this.handleError));

  }

  public saveNewImplementInspection(newInspectionModel: InspectedImplementsViewModel) {
    newInspectionModel.InspectionStringDate = newInspectionModel.InspectionDate.toLocaleDateString('en-US');
    return this._http.post('api/GETNewInspection/SaveNewImplementInspection', newInspectionModel)
      .pipe(catchError(this.handleError));
  }


  uploadNewPhotoToObservationPoint(observationPoint: InspectionObservationPointsViewModel, newPhoto: string): any {
    const model = new UploadNewImagesToObservationPointModel();
    model.ImageData = newPhoto;
    model.ObservationPointInspectionId = observationPoint.Id;
    return this._http.post('api/GETNewInspection/UploadNewPhotoToObservationPoint', model)
      .pipe(catchError(this.handleError));
  }

  public uploadNewPhotoToImplementInspectionImages(implementInspectionId: number, imageData: string): Observable<Tuple> {
    const model = new NewImageForImplementInspectionViewModel();
    model.ImageData = imageData;
    model.ImplementInspectionId = implementInspectionId;
    return this._http.post<Tuple>('api/GETNewInspection/UploadNewPhotoToImplementInspectionImages', model)
      .pipe(catchError(this.handleError));
  }

  public updateInpsectionImage(imageId: number, imageData: string) {
    const model = new UpdateInspectionImagePhotoViewModel();
    model.ImageId = imageId;
    model.ImageData = imageData;
    return this._http.post('api/GETNewInspection/UpdateInspectionImage', model)
      .pipe(catchError(this.handleError));
  }

  public UpdateIncludeOnReport(implementInspectionId: number, isIncludeOnReport: boolean) {
    const options = {
      params: new HttpParams()
        .set('implementInspectionId', implementInspectionId.toString())
        .set('isIncludeOnReport', isIncludeOnReport.toString())
    };
    return this._http.get('api/GETNewInspection/UpdateIncludeOnReport', options)
      .pipe(catchError(this.handleError));
  }

  public UpdateIncludeCommentOnReport(implementInspectionId: number, isIncludeCommmentOnReport: boolean) {
    const options = {
      params: new HttpParams()
        .set('implementInspectionId', implementInspectionId.toString())
    };
    return this._http.get('api/GETNewInspection/UpdateIncludeCommentOnReport', options)
      .pipe(catchError(this.handleError));
  }



  public GetInspectionTemplatesBySelectedImplementId(implementId: number): Observable<InspectedImplementsViewModel> {
    const options = {
      params: new HttpParams().set('implementId', implementId.toString())
    };
    return this._http.get<InspectedImplementsViewModel>('api/GETNewInspection/GetImplementTemplateToBeInspected', options)
      .pipe(catchError(this.handleError));
  }

  public GetInspectionTemplatesBySelectedImplementIdOnInventory(implementId: number): Observable<InspectedImplementsViewModel> {
    const options = {
      params: new HttpParams().set('implementId', implementId.toString())
    };
    return this._http.get<InspectedImplementsViewModel>('api/GETNewInspection/GetImplementTemplateToBeInspectedOnInventory', options)
      .pipe(catchError(this.handleError));
  }


  public GetImplementInspectionView(ImplementInspectionId: number): Observable<InspectedImplementsViewModel> {
    const options = {
      params: new HttpParams().set('ImplementInspectionId', ImplementInspectionId.toString())
    };
    return this._http.get<InspectedImplementsViewModel>('api/GETNewInspection/GetImplementInspectionView', options)
      .pipe(catchError(this.handleError));
  }


  public returnGETById(id: number): Observable<ImplementDetails> {
    const options = {
      params: new HttpParams().set('get_auto', id.toString())
    };
    return this._http.get('Api/Implement/ReturnGETById', options).map(j => JSON.parse(j.toString())).pipe(catchError(this.handleError));
  }


  public GetImplementInspectionsByEquipmentIdAndDate(inspectionRequest: InspectionRequestModel):
    Observable<InspectedImplementsViewModel[]> {
    return this._http.post<InspectedImplementsViewModel[]>('api/GETNewInspection/GetImplementInspectionsByEquipmentIdAndDate', inspectionRequest)
      .pipe(catchError(this.handleError));
  }

  public GetImplementInspectionsByInspectionId(inspectionId: number):
    Observable<InspectedImplementsViewModel[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<InspectedImplementsViewModel[]>('api/GETNewInspection/GetImplementInspectionsByInspectionId', options)
      .pipe(catchError(this.handleError));
  }

  public GetGeneralInspectionsInfo(inspectionId: number):
    Observable<InspectedImplementsViewModel[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<InspectedImplementsViewModel[]>('api/GETNewInspection/GetGeneralInspectionsInfo', options)
      .pipe(catchError(this.handleError));
  }

  public GetWearPackageStatusByInspectionId(inspectionId: number):
    Observable<InspectedImplementsViewModel[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<InspectedImplementsViewModel[]>('api/GETNewInspection/GetImplementInspectionsByInspectionId', options)
      .pipe(catchError(this.handleError));
  }

  public RefreshReportOptionByInspectionId(inspectionId: number):
    Observable<any> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get('api/GETNewInspection/RefreshReportOptionByInspectionId', options)
      .pipe(catchError(this.handleError));
  }

  public ReCalculateInspectionByInspectionId(inspectionId: number):
    Observable<any> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get('api/GETNewInspection/ReCalculateInspectionByInspectionId', options)
      .pipe(catchError(this.handleError));
  }
  

  public GetComponentTypesByInspectionId(inspectionId: number):
    Observable<ReportOptionsVm[]> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<ReportOptionsVm[]>('api/GETNewInspection/GetComponentTypesByInspectionId', options)
      .pipe(catchError(this.handleError));
  }

  public GetImageRotations(): Observable<GenericIdName[]> {

    return this._http.get<GenericIdName[]>('api/GETNewInspection/GetImageRotations')
      .pipe(catchError(this.handleError));
  }

  public CompTypeOrderUp(ImpInspectionId: number, Order: number):
    Observable<any> {
    const options = {
      params: new HttpParams().set('ImpInspectionId', ImpInspectionId.toString()).set('Order', Order.toString())
    };
    return this._http.get('api/GETNewInspection/ArrowUpCompTypeOrder', options)
      .pipe(catchError(this.handleError));
  }

  public CompTypeOrderDown(ImpInspectionId: number, Order: number, ):
    Observable<any> {
    const options = {
      params: new HttpParams().set('ImpInspectionId', ImpInspectionId.toString()).set('Order', Order.toString())
    };
    return this._http.get('api/GETNewInspection/ArrowDownCompTypeOrder', options)
      .pipe(catchError(this.handleError));
  }

  public GetImplementQuestions(): Observable<InspectedImplementsViewModel[]> {
    return this._http.get<InspectedImplementsViewModel[]>('api/GETNewInspection/GetImplementQuestions').pipe(catchError(this.handleError));
  }

  public ChangedImplementGeneralQuestion(implementInspectionId: number, question, answer) {
    const model = new UpdateImplementLevelEquipmentAnswersModel();
    model.ImplementInspectionId = implementInspectionId;
    model.Question = question;
    model.SelectedAnswer = answer;
    return this._http.post('api/GETNewInspection/ChangedImplementGeneralQuestionAnswers', model)
      .pipe(catchError(this.handleError));
  }


  public UpdateGroupOrder(TypeList: Array<ReportOptionsVm>):
    Observable<ReportOptionsVm[]> {

    return this._http.post<ReportOptionsVm[]>('api/GETNewInspection/UpdateGroupOrder', TypeList)
      .pipe(catchError(this.handleError));

  }


  public updateObservationPointImages(imageId: number, imageData: string) {
    const model = new UpdateInspectionImagePhotoViewModel();
    model.ImageId = imageId;
    model.ImageData = imageData;
    return this._http.post('api/GETNewInspection/UpdateObservationPointImages', model)
      .pipe(catchError(this.handleError));
  }
  public deleteObservationPointImage(imageId: number): Observable<any> {
    const options = {
      params: new HttpParams()
        .set('imageId', imageId.toString())
    };
    return this._http.get('api/GETNewInspection/DeleteObservationPointImages', options)
      .pipe(catchError(this.handleError));
  }


  public updateCommentOnObservationPoints(observationPointId: number, newComment: string) {
    const model = new UpdateObservationCommentViewModel();
    model.ObservationPointInspectionId = observationPointId;
    model.Comment = newComment;
    return this._http.post('api/GETNewInspection/UpdateObservationComments', model)
      .pipe(catchError(this.handleError));
  }

  public updateCommentOnCheckListAnswer(AnswerId: number, newComment: string) {
    const model = new UpdatePreCheckListCommentViewModel();
    model.AnswerId = AnswerId;
    model.Comment = newComment;
    return this._http.post('api/GETNewInspection/UpdateCheckListComments', model)
      .pipe(catchError(this.handleError));
  }


  public getObservationPointInspection(componentObservationInspectionId: number): Observable<InspectionObservationPointsViewModel> {
    const options = {
      params: new HttpParams().set('componentObservationInspectionId', componentObservationInspectionId.toString())
    };
    return this._http.get<InspectionObservationPointsViewModel>('api/GETNewInspection/ViewObservationPoint', options)
      .pipe(catchError(this.handleError));
  }

  public GetAllObservationPointsByCompType(SchematicId: number, GETComponentTypeId: number, implementInspectionId: number, obsPointId: number = 0): Observable<InspectionCompTypeCompObsPoints[]> {
    const options = {
      params: new HttpParams().set('SchematicId', SchematicId.toString()).set('ComponentTypeId', GETComponentTypeId.toString()).set('ImplementInspectionId', implementInspectionId.toString()).set('ObsPointId', obsPointId.toString())
    };
    return this._http.get<InspectionCompTypeCompObsPoints[]>('api/GETNewInspection/GetAllObservationPointsByCompType', options)
      .pipe(catchError(this.handleError));
  }

  public deleteInspectionImage(implementInspectionId: number, imageId: number): Observable<any> {
    const options = {
      params: new HttpParams()
        .set('implementInspectionId', implementInspectionId.toString())
        .set('imageId', imageId.toString())
    };
    return this._http.get('api/GETNewInspection/DeleteInspectionImage', options)
      .pipe(catchError(this.handleError));
  }

  ChangedObservationLevelQuestionAnswers(ObservationPoint: InspectionObservationPointsViewModel): any {
    return this._http.post('api/GETNewInspection/ChangedObservationLevelQuestionAnswers', ObservationPoint)
      .pipe(catchError(this.handleError));
  }
  public deleteComponentImage(compart_attach_auto: number) {
   
    const model = new UpdateComponentImageViewModel();
    model.compart_attach_auto = compart_attach_auto;
    //model.ImageData = imageData;
    return this._http.post('api/Component/DeleteComponentImage', model)
      .pipe(catchError(this.handleError));
  }

  updateMeasurementReadingOnObservationPoint(measurement: number, Id: number): any {
    const options = {
      params: new HttpParams()
        .set('ObservationMeasurementReadingId', Id.toString())
        .set('newReading', measurement.toString())
    };
    return this._http.get('api/GETNewInspection/UpdateMeasurementReadingOnObservationPoint', options)
      .pipe(catchError(this.handleError));
  }



  updateOverallInspectionComment(model: InspectionOverallCommentUpdateCommentViewModel) {
    // const model = new InspectionOverallCommentUpdateCommentViewModel();
    // model.ImplementInspectionId = implementInspectionId;
    // model.CommentContent = newComment;
    return this._http.post('api/GETNewInspection/UpdateInspectionOverallComment', model)
      .pipe(catchError(this.handleError));
  }


  ChangeReportingGroupType(componentInspectionId: number, reportGroupType: number) {
    const model = new ComponentReprtGroupUpdateModel();
    model.componentInspectionId = componentInspectionId;
    model.ChangeReportingGroup = reportGroupType;
    return this._http.post('api/GETNewInspection/ChangeReportingGroup', model)
      .pipe(catchError(this.handleError));
  }


  public AddNewMeasurementReadingToObservationPointInspection
    (ObservationPointInspectionId: number, reading: number, position: number): Observable<Tuple> {
    const model = new AddNewMeasurementToObservationPointModel();
    model.ObservationPointInspectionId = ObservationPointInspectionId;
    model.ReadingPosition = position;
    return this._http.post<Tuple>('api/GETNewInspection/AddNewMeasurementOnObservation', model)
      .pipe(catchError(this.handleError));
  }



  getEvalClass(wornPct: number) {
    if (wornPct <= 30) {
      return ' WornPctCell evalColorA';
    } else if ((wornPct > 30) && (wornPct <= 60)) {
      return ' WornPctCell evalColorB';
    } else if ((wornPct > 60) && (wornPct <= 80)) {
      return ' WornPctCell evalColorC';
    } else if (wornPct > 80) {
      return 'WornPctCell evalColorX';
    }
    return ' WornPctCell noEval';
  }

  getEvalClass2(wornPct: number) {
    if ((wornPct > 0) && (wornPct <= 30)) {
      return ' WornPctCell evalColorA';
    } else if ((wornPct > 30) && (wornPct <= 60)) {
      return ' WornPctCell evalColorB';
    } else if ((wornPct > 60) && (wornPct <= 80)) {
      return ' WornPctCell evalColorC';
    } else if (wornPct > 80) {
      return 'WornPctCell evalColorX';
    } else if (wornPct == 0) {
      return ' WornPctCell noEval';
    }
  }

  getEvalCode2(wornPct: number) {
    if ((wornPct > 0) && (wornPct <= 30)) {
      return 'A';
    } else if ((wornPct > 30) && (wornPct <= 60)) {
      return 'B';
    } else if ((wornPct > 60) && (wornPct <= 80)) {
      return 'C';
    } else if (wornPct > 80) {
      return 'X';
    } else if (wornPct == 0) {
      return 'U';
    }
  }


  toggleComponentInspectionFlag(componentInspectionId: number) {
    return this._http.post('api/GETNewInspection/ToggleComponentInspectionFlag', componentInspectionId)
      .pipe(catchError(this.handleError));
  }

  toggleComponentInspectionIncludeReport(componentInspectionId: number) {
    return this._http.post('api/GETNewInspection/ToggleComponentInspectionIncludeReport', componentInspectionId)
      .pipe(catchError(this.handleError));
  }

  toggleObservationInspectionIncludeReport(observationId: number) {
    return this._http.post('api/GETNewInspection/ToggleObservationInspectionIncludeReport', observationId)
      .pipe(catchError(this.handleError));
  }

  toggleReportInspectionIncludeSummary(Id: number) {
    return this._http.post('api/GETNewInspection/ToggleReportInspectionIncludeSummary', Id)
      .pipe(catchError(this.handleError));
  }

  toggleReportInspectionIncludeSchematicInSummary(Id: number) {
    return this._http.post('api/GETNewInspection/ToggleReportInspectionIncludeSchematicInSummary', Id)
      .pipe(catchError(this.handleError));
  }

  toggleReportInspectionIncludeGraph(Id: number) {
    return this._http.post('api/GETNewInspection/ToggleReportInspectionIncludeGraph', Id)
      .pipe(catchError(this.handleError));
  }

  toggleReportInspectionChartType(Id: number, ChartType: number) {
    const model = new ReportOptionValue();
    model.Id = Id;
    model.selectedValue = ChartType;
    return this._http.post('api/GETNewInspection/UpdateReportChartType', model)
      .pipe(catchError(this.handleError));
  }


  toggleReportInspectionIncludeDataTable(Id: number) {
    return this._http.post('api/GETNewInspection/ToggleReportInspectionIncludeDataTable', Id)
      .pipe(catchError(this.handleError));
  }
  toggleReportInspectionIncludeBody(Id: number) {
    return this._http.post('api/GETNewInspection/ToggleReportInspectionIncludeBody', Id)
      .pipe(catchError(this.handleError));
  }

  public RemoveObservationMeasurment(obsInspectionReadingId: number): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('obsInspectionReadingId', obsInspectionReadingId.toString())
    };
    return this._http.get<Tuple>('api/GETNewInspection/DeleteObservationPointReading', options)
      .pipe(catchError(this.handleError));
  }

  public UpdateObservationInspectionFlag(obsInspectionId: number, flag: boolean): Observable<Tuple> {
    const options = {
      params: new HttpParams().set('obsInspectionId', obsInspectionId.toString()).set('flag', flag.toString())
    };
    return this._http.get<Tuple>('api/GETNewInspection/UpdateObservationInspectionFlag', options)
      .pipe(catchError(this.handleError));
  }

  UpdateReportComTypeOverallEval(Id: number, value: number) {

    const model = new ReportOptionValue();
    model.Id = Id;
    model.selectedValue = value;
    return this._http.post('api/GETNewInspection/UpdateReportComTypeOverallEval', model)
      .pipe(catchError(this.handleError));
  }
  UpdateReportComTypeImageRotation(Id: number, value: number) {

    const model = new ReportOptionValue();
    model.Id = Id;
    model.selectedValue = value;
    return this._http.post('api/GETNewInspection/UpdateReportComTypeImageRotation', model)
      .pipe(catchError(this.handleError));
  }
  

  UpdateReportSummaryComment(Id: number, comment: string) {

    const model = new ReportOptionValue();
    model.Id = Id;
    model.Comment = comment;
    return this._http.post('api/GETNewInspection/UpdateReportComTypeSummaryComment', model)
      .pipe(catchError(this.handleError));
  }
  UpdateReportRepairComment(Id: number, comment: string) {

    const model = new ReportOptionValue();
    model.Id = Id;
    model.Comment = comment;
    return this._http.post('api/GETNewInspection/UpdateReportRepairComment', model)
      .pipe(catchError(this.handleError));
  }
  UpdateReportGeneralComment(Id: number, comment: string) {

    const model = new ReportOptionValue();
    model.Id = Id;
    model.Comment = comment;
    return this._http.post('api/GETNewInspection/UpdateReportGeneralComment', model)
      .pipe(catchError(this.handleError));
  }
  UpdateReportGroupName(Id: number, groupName: string) {

    const model = new ReportOptionValue();
    model.Id = Id;
    model.AlterGroupName = groupName;
    return this._http.post('api/GETNewInspection/UpdateReportComTypeGroupName', model)
      .pipe(catchError(this.handleError));
  }

  public UpdateWearStatusPackage(searchFields: WearStatusPackages): Observable<any> {
    return this._http.post('api/GETNewInspection/UpdateWearStatusPackage', searchFields)
    .pipe(catchError(this.handleError));
  } 

  toggleAllObservations(componentInspectionId: number, value: boolean) {

    const model = new UpdateIncludeReportObservation();
    model.ComInspectionId = componentInspectionId;
    model.Value = value;
    return this._http.post('api/GETNewInspection/ToggleAllObservationInspectionIncludeReport', model)
      .pipe(catchError(this.handleError));
  }


  public updateEquipmentImage(equipmentId: number, imageData: string) {
    const model = new UpdateInspectionImagePhotoViewModel();
    model.ImageId = equipmentId;
    model.ImageData = imageData;
    return this._http.post('api/GETEquipment/UpdateEquipmentImage', model)
      .pipe(catchError(this.handleError));
  }
  public updateComponentImage(compart_attach_auto: number, imageData: string, imageId: number) {
    
    const model = new UpdateComponentImageViewModel();
    model.compart_attach_auto = compart_attach_auto;
    model.ImageData = imageData;
    model.ImageId = imageId;
    if (imageId > 0)
      return this._http.post('api/Component/AddComponentImages', model).pipe(catchError(this.handleError));
    else
      return this._http.post('api/Component/UpdateComponenetImage', model).pipe(catchError(this.handleError));
  }

  public updateFECRAdditionObsImage(ImageId: number, imageData: string) {
    const model = new UpdateInspectionImagePhotoViewModel();
    model.ImageId = ImageId;
    model.ImageData = imageData;
    return this._http.post('api/FECRImplement/UpdateFECRAdditonalObsImage', model)
      .pipe(catchError(this.handleError));
  }

  UploadNewPhotoFECRAdditionObsPoint(obsInfo: FECRPrePostAdditionalObsVM, newPhoto: string): any {
    const model = new UploadNewImagesToObservationPointModel();
    model.ImageData = newPhoto;
    model.ObservationPointInspectionId = obsInfo.Id;
    return this._http.post('api/FECRImplement/UploadNewPhotoFECRAdditionObsPoint', model)
      .pipe(catchError(this.handleError));
  }

  public deleteFECRAdditionaObsImage(imageId: number): Observable<any> {
    const options = {
      params: new HttpParams()
        .set('imageId', imageId.toString())
    };
    return this._http.get('api/FECRImplement/DeleteFECRAdditionaObsImage', options)
      .pipe(catchError(this.handleError));
  }
 
  UpdatCrackSeverityOnObservationPoint(observationPointInspectionID: number, severityID: number): any {
    const options = {
      params: new HttpParams()
        .set('observationPointInspectionID', observationPointInspectionID.toString())
        .set('severityID', severityID.toString())
        
    };
    return this._http.get('api/GETNewInspection/UpdatCrackSeverityOnObservationPoint', options)
      .pipe(catchError(this.handleError));
  }

  UpdatObsSeveritiesOnObservationPoint(observationPointInspectionID: number, severityIDs: number[]): any {
    console.log("severityIDs:", severityIDs)
    const options = {
      params: new HttpParams()
        .set('observationPointInspectionID', observationPointInspectionID.toString())
        .set('severityIDs', severityIDs.join(','))
    };
    return this._http.get('api/GETNewInspection/UpdatObsSeveritiesOnObservationPoint', options)
      .pipe(catchError(this.handleError));
  }

recordComponentInspectionForObsPoint(obsPointID: number, ImplementInspectionID: number): any {
    const options = {
      params: new HttpParams()
        .set('obsPointID', obsPointID.toString())
        .set('ImplementInspectionID', ImplementInspectionID.toString())
        
    };
    return this._http.get('api/GETNewInspection/recordComponentInspectionForObsPoint', options)
      .pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    console.log(error);
    return Observable.throw(error.message || 'Server error');
  }

  public GetAssetDetail(equipmentId: number,getId:number):
    Observable<AssetDetail> {
    const options = {
      params: new HttpParams()
      .set('equipmentId', equipmentId.toString())
      .set('inspectionId',getId.toString())
    };
    return this._http.get<AssetDetail>('api/Implement/GetAssetDetail', options)
      .pipe(catchError(this.handleError));
  }

  public CheckImplementReportConfiqAtInsection(getId:number):
  Observable<boolean> {
  const options = {
    params: new HttpParams()
    .set('inspectionId',getId.toString())
  };
  return this._http.get<boolean>('api/Implement/CheckImplementAtInsection', options)
    .pipe(catchError(this.handleError));
}

public CheckImplementReportConfiqAtAsset(getId:number):
  Observable<boolean> {
  const options = {
    params: new HttpParams()
    .set('inspectionId',getId.toString())
  };
  return this._http.get<boolean>('api/Implement/CheckImplementAtAsset', options)
    .pipe(catchError(this.handleError));
}
public FillComponentTypeReportConfigurations(getId:number):
  Observable<boolean> {
  const options = {
    params: new HttpParams()
    .set('inspectionId',getId.toString())
  };
  return this._http.get<boolean>('api/Implement/FillComponentTypeReportConfigurations', options)
    .pipe(catchError(this.handleError));
  }

  public getInspectionImages(inspectionId: number): Observable<any> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<any>('api/GETNewInspection/GetInspectionImages', options)
      .pipe(catchError(this.handleError));
  }

  public getInspectionGeneralQuestions(inspectionId: number): Observable<any> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<any>('api/GETNewInspection/GetInspectionGeneralQuestions', options)
      .pipe(catchError(this.handleError));
  }

  //public getInspectionComponentTypes(inspectionId: number): Observable<any> {
  //  const options = {
  //    params: new HttpParams().set('inspectionId', inspectionId.toString())
  //  };
  //  return this._http.get<any>('api/GETNewInspection/GetInspectionComponentTypes', options)
  //    .pipe(catchError(this.handleError));
  //}

  public getInspectionComponentTypes(inspectionId: number, implementInspectionID: number): Observable<any> {
    const options = {
      params: new HttpParams().set('GETAuto', inspectionId.toString()).set('ImplementInspectionId', implementInspectionID.toString())
    };
    return this._http.get<any>('api/GETNewInspection/GetInspectionComponentTypes', options)
      .pipe(catchError(this.handleError));
  }


  public getInspectionComponents(inspectionId: number): Observable<any> {
    const options = {
      params: new HttpParams().set('inspectionId', inspectionId.toString())
    };
    return this._http.get<any>('api/GETNewInspection/GetInspectionComponents', options)
      .pipe(catchError(this.handleError));
  }

  public CheckCrackSeverityListForCustomer(EquipmentID: number): Observable<any> {
    const options = {
      params: new HttpParams().set('EquipmentID', EquipmentID.toString())
    };
    return this._http.get<any>('api/EquipmentDetails/CheckCrackSeverityListForCustomer', options)
      .pipe(catchError(this.handleError));
  }

  public checkCrackObsListForCustomer(EquipmentID: number): Observable<any> {
    const options = {
      params: new HttpParams().set('EquipmentID', EquipmentID.toString())
    };
    return this._http.get<any>('api/EquipmentDetails/CheckCrackObsListForCustomer', options)
      .pipe(catchError(this.handleError));
  }

   public GetSequentialNumber(): Observable<number> {
    
    return this._http.get<number>('api/GETNewInspection/GetSequentialNumber')
      .pipe(catchError(this.handleError));
  }

     UpdateWorkOrder(ImplementInspectionId: number, WorkOrder:string): any {
    const model = new WorkOrderUpdate();
    model.ImplementInspectionId = ImplementInspectionId;
    model.WorkOrder = WorkOrder;
    return this._http.post('api/GETNewInspection/UpdateWorkOrderNumber', model)
      .pipe(catchError(this.handleError));
  }

  mySubject = new Subject<boolean>();

  public GetCrackObsLocations(componentId: number): Observable<OBSseveityList[]> {
    const options = {
      params: new HttpParams().set('ComponentId', componentId.toString())
    };
    return this._http.get<OBSseveityList[]>('api/GETNewInspection/GetCrackObsLocations', options)
      .pipe(catchError(this.handleError));
  }
}





